import routes from '../routes';
import reducer from './reducers/index';
import * as CoASelectors from './selectors';
import * as CoAOperations from './operations';
import * as CoAActions from './actions';

export {
    CoASelectors,
    CoAOperations,
    CoAActions
};

export default {
    routes,
    reducer
};
